import { Conversation, ConversationStatus } from 'generated-graphql/types';
import { ConversationStatusFilter } from '../constants/enums';

export const getConversationStatusFilter = (
  value: ConversationStatusFilter,
  conversation: Conversation
) => {
  switch (value) {
    case ConversationStatusFilter.REVIEW:
      return conversation.needsReview;
    case ConversationStatusFilter.CREATED:
      return conversation.status === ConversationStatus.Created;
    case ConversationStatusFilter.ONGOING:
      return conversation.status === ConversationStatus.Ongoing;
    case ConversationStatusFilter.OPTED_OUT:
      return conversation.status === ConversationStatus.OptedOut;
    case ConversationStatusFilter.QUEUED:
      return conversation.status === ConversationStatus.Queued;
    case ConversationStatusFilter.CLOSED:
      return (
        conversation.status === ConversationStatus.Completed ||
        conversation.status === ConversationStatus.CompletedCustomRequest ||
        conversation.status === ConversationStatus.CompletedMeetingRequested ||
        conversation.status === ConversationStatus.CompletedAwaitingCall ||
        conversation.status === ConversationStatus.CompletedRejected
      );
    case ConversationStatusFilter.NOT_DELIVERED:
      return conversation.status === ConversationStatus.DeliveryFailed;
  }
};
